import React from 'react';
import useExcelStyles from '../useExcelStyles';
import useNoRowsTemplate from '../useNoRowsOverlay';
import useLoadingOverlay from '../useLoadingOverlay';
import { RootState, useSelector } from '../../../redux/store';
import getOptionsRowNodeId from '../../../utils/manage-condition/getOptionsRowNodeId';
import { TOOLTIP_SHOW_DELAY } from '../../../constants';
import type { ExcelStyle, GetContextMenuItemsParams, GridOptions, MenuItemDef } from 'ag-grid-community';
import type { RowClassRules, RowClassParams } from '../../../types/common';
import type { ConditionDetailType, ConditionOptionsData } from '../../../types/condition';

const useGridOptionsConditionOrdinary = () => {
  const { commonExcelStyles } = useExcelStyles();
  const { condition, selectedViewMode } = useSelector((state: RootState) => state.condition);

  // Excelのスタイル設定
  // ----------------------------------------
  const excelStyles: ExcelStyle[] = [...commonExcelStyles];

  // Overlayの設定
  // ----------------------------------------
  const overlayLoadingTemplate: string = useLoadingOverlay();
  const overlayNoRowsTemplate: string = useNoRowsTemplate();

  // rowNodeIdの設定
  // ----------------------------------------
  const getRowNodeId = (params: ConditionOptionsData) => getOptionsRowNodeId(params);

  // 右クリックメニューの設定
  // ----------------------------------------
  const getContextMenuItems = (params: GetContextMenuItemsParams): (string | MenuItemDef)[] => {
    // console.log(params);
    if (params.node) {
      const menuItems = ['copy', 'copyWithHeaders', 'separator', 'export'];
      return menuItems;
    } else {
      return [];
    }
  };

  // 色付けの設定
  // ----------------------------------------
  const rowClassRules: RowClassRules = {
    'has-diff': (params: RowClassParams): boolean => {
      // console.log(params);

      if (selectedViewMode === 'EDITING') {
        const data: ConditionDetailType = params.data;
        const detailCustomizeApprove: ConditionDetailType[] | undefined = condition?.detailCustomizeApprove;
        const exsisting: ConditionDetailType | undefined = detailCustomizeApprove?.find((detail) => {
          if (
            // 可視制御7項目の値が同じものを探す
            // null/''の可能性がある　→　''に揃えて比較する
            (detail.customer ?? '') === (data.customer ?? '') &&
            (detail.customer1 ?? '') === (data.customer1 ?? '') &&
            (detail.customer2 ?? '') === (data.customer2 ?? '') &&
            (detail.customer3 ?? '') === (data.customer3 ?? '') &&
            (detail.deliveryLocation ?? '') === (data.deliveryLocation ?? '') &&
            (detail.standard ?? '') === (data.standard ?? '') &&
            (detail.sizeDisplay ?? '') === (data.sizeDisplay ?? '')
          ) {
            return true;
          } else {
            return false;
          }
        });
        // console.log(exsisting);

        // 存在しないものに対してクラスを付与する
        return exsisting === undefined ? true : false;
      } else {
        return false;
      }
    },
  };

  // GridOptions全体
  // ----------------------------------------
  const gridOptions: GridOptions = {
    allowContextMenuWithControlKey: true,
    enableRangeSelection: true,
    excelStyles,
    getContextMenuItems,
    getRowNodeId,
    rowClassRules,
    overlayLoadingTemplate,
    overlayNoRowsTemplate,
    tooltipShowDelay: TOOLTIP_SHOW_DELAY,
  };

  return { gridOptions };
};

export default useGridOptionsConditionOrdinary;
